<template>
<div class="login">
	<v-form ref="connection" v-model="valid">
		<v-container>
			<v-layout column>

				<v-flex xs12 md4>
					<v-text-field id="email" v-model="mail" :rules="mailRules" label="Email" required></v-text-field>
				</v-flex>

				<v-flex xs12 md4>
					<v-text-field type="password" v-model="password" :rules="passwordRules" label="Mot de passe" required></v-text-field>
				</v-flex>

				<v-flex xs12 md4>
					<v-checkbox v-model="stayConnected" label="rester connecté" required></v-checkbox>
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>

	<v-btn @click="connect">Se connecter</v-btn>
</div>
</template>

<script>
import { AUTH_REQUEST, GET_USER, AUTH_LOGOUT, ERROR, SUCCESS } from '../variables'
export default {
	data() {
		return {
			valid: false,
			stayConnected: null,
			mail: null,
			password: null,
			mailRules: [
				v => !!v || 'Email requis',
				v => {
					const pattern = /^[a-zA-Z0-9]([.\-_]?[a-zA-Z0-9])*@[a-zA-Z0-9]([.\-_]?[a-zA-Z0-9])*.[a-zA-Z]{2,4}$/
					return pattern.test(v) || 'Email invalide'
				}
			],
			passwordRules: [
				v => !!v || 'mot de passe requis'
			]
		}
	},
	methods: {
		sendForgottenPassword() {
			this.$refs.connection.resetValidation()
			let copyMailRules = this.mailRules
			this.mailRules = []
			if (this.mail) {
				let buff = Buffer.from(this.mail)
				this.axios.get('users/password/' + buff.toString('base64'))
					.then((res) => {
						this.loading = false
						this.$store.dispatch(SUCCESS, 'Le mail de modification de mot de passe a été envoyé')
					})
					.catch((err) => {
						console.log(err)
						this.loading = false
						this.$store.dispatch(ERROR, 'Une erreur est survenue lors de l\'envoidu mail de changement de mot de passe')
					})
			} else {
				setTimeout(function() {
					this.$refs.connection.validate()
				}.bind(this), 200)
			}
			this.mailRules = copyMailRules
		},
		connect() {
			this.$refs.connection.resetValidation()
			if (!this.valid) {
				setTimeout(function() {
					this.$refs.connection.validate()
				}.bind(this), 200)
			}
			if (this.valid) {
				this.$store.dispatch(AUTH_REQUEST, {
						mail: this.mail,
						password: this.password,
						stayConnected: this.stayConnected
					})
					.then(() => {
						this.mail = null
						this.password = null
						this.stayConnected = null
						this.$store.dispatch(GET_USER, this.$store.getters.userId)
							.then(() => {
								this.$router.push({ name: 'ProUserList' })
							})
							.catch((err) => {
								console.log(err)
								this.$store.dispatch(AUTH_LOGOUT)
							})
					})
					.catch((err) => {
						console.log(err)
						this.$store.dispatch(ERROR, 'Une erreur est survenue lors de la connexion')
					})
			}
		}
	}
}
</script>

<style lang="scss">
.login {
    width: 50% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue